import { render, staticRenderFns } from "./ReportsItems.vue?vue&type=template&id=aefdf5b2&"
import script from "./ReportsItems.vue?vue&type=script&lang=js&"
export * from "./ReportsItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports